import * as React from 'react';
import {faTimes} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import Button from '../../ui/Buttons/Button';
import {compareItems, removeAllItems, removeItem} from './CompareFunctions';
import {Item} from '../item.class';
import {ProductImage} from '../../ui/ProductImage/ProductImage';

export const CompareItems = () => {
    /**
     * Builds compare URL and navigates to it
     */
    const navCompareItems = () => {
        let url = `/compare`;
        compareItems.value.forEach((compareItem, index) => {
            url += index === 0 ? `?itemNums=${compareItem.itemNum}` : `&itemNums=${compareItem.itemNum}`;
        });
        location.assign(url);
    };

    /**
     * Template
     */
    if (!compareItems.value.length) {
        return <></>;
    }
    return (
        <div className="tw-fixed tw-bottom-0 tw-z-[1024] tw-bg-white tw-w-full tw-flex tw-justify-center tw-pb-4 tw-px-4 sm:tw-pb-0 sm:tw-px-0 tw-left-0 tw-shadow-[0_-10px_10px_-3px_rgba(0,0,0,0.3)]">
            <div className="tw-flex tw-flex-col tw-justify-center tw-items-center">
                <div className="tw-flex tw-flex-row tw-flex-wrap tw-justify-center tw-items-center">
                    {[...compareItems.value, null, null].slice(0, 3).map((compareItem, index) => (
                        <div
                            className={`tw-text-right ${index < 2 && 'tw-border-r tw-border-r-gray-150'} tw-p-4`}
                            key={compareItem ? compareItem.itemNum : `empty-${index}`}
                        >
                            {compareItem ? (
                                <div className="tw-flex tw-flex-row tw-justify-center">
                                    <div>
                                        <ProductImage
                                            altText={`Product image for item#${compareItem.itemNum}`}
                                            className="tw-w-[50px] tw-h-[50px]"
                                            src={compareItem.imagePath}
                                            size={75}
                                        />
                                        <div className="tw-text-center tw-mt-2">
                                            <a href={`/item/${compareItem.itemNum}`}>{Item.prettyItem(compareItem.itemNum)}</a>{' '}
                                        </div>
                                    </div>
                                    <div>
                                        <Button
                                            aria-label="Remove Item"
                                            className="tw-pl-4 tw-py-2 -tw-mr-3 -tw-mt-3 tw-h-[25px]"
                                            onClick={() => removeItem(compareItem.itemNum)}
                                            type="button"
                                            variant="link"
                                        >
                                            <FontAwesomeIcon
                                                className="tw-text-gray-900"
                                                icon={faTimes}
                                                size="lg"
                                            />
                                        </Button>
                                    </div>
                                </div>
                            ) : (
                                <p className="tw-w-[82px] tw-text-center">Add up to three items</p>
                            )}
                        </div>
                    ))}
                    <div className="tw-flex tw-items-center tw-pt-4 sm:tw-pt-0 sm:tw-ml-6">
                        <Button
                            className="!tw-px-3 tw-mr-3"
                            disabled={compareItems.value.length < 2}
                            onClick={navCompareItems}
                            size="sm"
                            type="button"
                            variant="secondary"
                        >
                            Compare
                        </Button>
                        <Button
                            className="!tw-px-3"
                            onClick={removeAllItems}
                            type="button"
                            size="sm"
                            variant="outline-secondary"
                        >
                            Remove All
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};
